import type { PublicFormVersion } from '@kushya/shared';

export function getProgressMode(form?: PublicFormVersion) {
  return form?.ui.layout?.progressDisplay ?? 'questions';
}

export function getShowProgress(params: {
  form?: PublicFormVersion;
  hasPages: boolean;
  totalPages: number;
  totalQuestions: number;
}) {
  const { form, hasPages, totalPages, totalQuestions } = params;
  return (
    form?.ui.layout?.showProgress !== false &&
    (hasPages ? totalPages > 0 : totalQuestions > 0)
  );
}

export function getProgressPercentage(params: {
  progressMode: 'pages' | 'questions' | 'percentage';
  hasPages: boolean;
  hasIntro: boolean;
  currentPageIndex: number;
  currentStep: number;
  totalPages: number;
  totalQuestions: number;
  questionsBeforeCurrentPage: number;
  visitedQuestionCount: number;
}) {
  const {
    progressMode,
    hasPages,
    hasIntro,
    currentPageIndex,
    currentStep,
    totalPages,
    totalQuestions,
    visitedQuestionCount,
  } = params;

  const totalSteps = hasPages ? totalPages : totalQuestions + (hasIntro ? 1 : 0);
  const progressBasisCurrent = hasPages ? currentPageIndex + 1 : currentStep + 1;
  const questionProgressCurrent = Math.min(
    totalQuestions || 1,
    Math.max(visitedQuestionCount, 0),
  );

  if (progressMode === 'pages') {
    return totalSteps > 0 ? Math.round((progressBasisCurrent / totalSteps) * 100) : 100;
  }

  return totalQuestions > 0
    ? Math.round((questionProgressCurrent / totalQuestions) * 100)
    : 100;
}
